var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / _Other / Circle / Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-_Other-/-Circle-/-Error",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,-1.623249e-15 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z M21.6029221,9.68033009 L16.122,15.16 L10.642767,9.68033009 C10.3295339,9.36709706 9.83790102,9.34099431 9.49493468,9.60202183 L9.40533009,9.68033009 C9.06362133,10.0220388 9.06362133,10.5760582 9.40533009,10.917767 L9.40533009,10.917767 L14.885,16.397 L9.40533009,21.8779221 C9.06362133,22.2196308 9.06362133,22.7736502 9.40533009,23.1153589 C9.74703884,23.4570677 10.3010582,23.4570677 10.642767,23.1153589 L16.122,17.635 L21.6029221,23.1153589 C21.9161551,23.428592 22.407788,23.4546947 22.7507543,23.1936672 L22.8403589,23.1153589 C23.1820677,22.7736502 23.1820677,22.2196308 22.8403589,21.8779221 L22.8403589,21.8779221 L17.36,16.397 L22.8403589,10.917767 C23.1820677,10.5760582 23.1820677,10.0220388 22.8403589,9.68033009 C22.4986502,9.33862133 21.9446308,9.33862133 21.6029221,9.68033009 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.d60f75999f232b598148b7846cdf2e80.svg";
export { ForwardRef as ReactComponent };